export default {
  mounted() {
    if (this.$refs.focus) {
      this.$refs.focus.focus();
    }
  },
};



// WEBPACK FOOTER //
// ./src/shared/mixins/autofocus-mixin.js